import { Fragment, useContext } from "react";
import { Container } from 'reactstrap'
import { Link, useNavigate } from "react-router-dom"
import { selectCurrentUser, set2FACredentials } from "../redux/features/auth/authSlice";
import { useAppDispatch, useAppSelector } from "../redux/hooks/hook";
import TotpForm from "../Auth/TotpForm";
import CustomizerContext from "../_helper/Customizer";
import logoWhite from '../assets/images/logo/logo.png';
import logoDark from '../assets/images/logo/logo_dark.png';
import { Image } from "../AbstractElements";

const TwoFAValidation = () => {
    const curUser = useAppSelector(selectCurrentUser);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { layoutURL } = useContext(CustomizerContext);
    const from = `/dashboard/default/${layoutURL}`;

    const handleCodeVerified = async (data) => {
        if(data) {
          dispatch(set2FACredentials({is2FARequired: true, is2FAValidated: true}))
          navigate(from, { replace: true });
        }
    }

    return (
        <Fragment>
            <section className="maintenance-sec">
                <div className="page-wrapper">
                    <div className="error-wrapper maintenance-bg">
                        <Container>
                            <div className="mb-2">
                                <Link className={`logo text-start`} to={process.env.PUBLIC_URL}>
                                    <Image attrImage={{ className: 'img-fluid for-light', src: logoWhite, alt: '2fa' }} />
                                    <Image attrImage={{ className: 'img-fluid for-dark', src: logoDark, alt: '2fa' }} />
                                </Link>
                            </div>

                            <TotpForm 
                                onSubmit={handleCodeVerified} 
                                useEmail={curUser.email}
                                displayImage={true} 
                            />
                        </Container>
                    </div>
                </div>
            </section>
        </Fragment>
    )
}

export default TwoFAValidation